export const PROMO_CODE_STATUS = {
  IN_PROGRESS: 'en cours',
};
